import { useEffect, useState } from 'react';
import styles from '../../../styles/MP/LaboratorioCemPorcentoRetorno.module.scss';
import { Form, Button } from 'react-bootstrap';

const OptionsSection = (props) => {
    const {
        handleCheckPeca,
        pecasSelecionadas,
        handleCheckTeste,
        testeEscolhido,
        handleCheckIndice,
        indiceEscolhido,
        setStatusEscolhido,
        statusEscolhido,
        listaPecas,
        listaTestes,
        listaIndicesFiltrada,
        handleFinalizarPeca,
    } = props;

    const [selectAll, setSelectAll] = useState(false); 

    const handleSelectAll = (e) => {
        const isChecked = e.target.checked;
        setSelectAll(isChecked);
        if (isChecked) {
            listaPecas.forEach((item) => {
                if (!pecasSelecionadas.includes(item.peca)) {
                    handleCheckPeca(item.peca);
                }
            });
        } else {
            listaPecas.forEach((item) => {
                if (pecasSelecionadas.includes(item.peca)) {
                    handleCheckPeca(item.peca);
                }
            });
        }
    };

    useEffect(() => {
        setSelectAll(listaPecas.length > 0 && listaPecas.every((item) => pecasSelecionadas.includes(item.peca)));
    }, [pecasSelecionadas, listaPecas]);

    return (
        <>
            <section className={styles.options_wrapper}>
                <section className={styles.options_col_peca}>
                    <div className={styles.options_header}>
                        <Form.Check
                            type="checkbox"
                            id="select_all_pecas"
                            label="Selecionar Todas"
                            onChange={handleSelectAll}
                            checked={selectAll}
                        />
                    </div>
                    <span className={styles.options_label}>PEÇAS</span>
                    <div className={styles.separator} />
                    <div className={styles.peca_opt_wrapper}>
                        {listaPecas.map((item, index) => {
                            return (
                                <div key={`peca_${item.peca}`} className={styles.options_opt}>
                                    <Form.Check
                                        type="checkbox"
                                        name="pec"
                                        id={`checkbox_${item.peca}`}
                                        onChange={() => handleCheckPeca(item.peca)}
                                        checked={pecasSelecionadas.includes(item.peca)}
                                        label={item.peca}
                                        style={{ margin: '0px' }}
                                        disabled={item.disabled}
                                    />
                                </div>
                            );
                        })}
                    </div>
                </section>
                <section className={styles.options_col_teste}>
                    <span className={styles.options_label}>TESTES PENDENTES</span>
                    <div className={styles.separator} />
                    <div className={styles.teste_opt_wrapper}>
                        {listaTestes.map((item, index) => {
                            return (
                                <div key={`teste_${item.id_teste}`} className={styles.options_opt}>
                                    <Form.Check
                                        type="radio"
                                        name="tar"
                                        id={`checkbox_${item.id_teste}`}
                                        onChange={() => handleCheckTeste(item)}
                                        checked={testeEscolhido.id_teste === item.id_teste}
                                        label={item.desc_teste}
                                        style={{ margin: '0px' }}
                                        disabled={item.disabled}
                                    />
                                </div>
                            );
                        })}
                    </div>
                </section>
                <section className={styles.options_col_indice}>
                    <span className={styles.options_label}>ÍNDICE</span>
                    <div className={styles.separator} />
                    <div className={styles.indice_opt_wrapper}>
                        {listaIndicesFiltrada.map((item, index) => {
                            return (
                                <div key={`indice_${item.indice}`} className={styles.options_opt}>
                                    <Form.Check
                                        type="radio"
                                        name="indice"
                                        id={`checkbox_${item.indice}`}
                                        onChange={() => handleCheckIndice(item)}
                                        checked={indiceEscolhido.indice === item.indice}
                                        label={item.indice}
                                        style={{ margin: '0px' }}
                                    />
                                </div>
                            );
                        })}
                    </div>
                </section>
                <section className={styles.options_col_status}>
                    <span className={styles.options_label}>STATUS</span>
                    <div className={styles.separator} />
                    <div className={styles.status_opt_wrapper}>
                        <Form.Check
                            type="radio"
                            name="st"
                            label="APROVADO"
                            value="Aprovado"
                            id={`checkbox_aprovado`}
                            onChange={(e) => setStatusEscolhido(e.target.value)}
                            checked={statusEscolhido === "Aprovado"}
                            disabled={indiceEscolhido.indice === undefined}
                        />
                        <Form.Check
                            type="radio"
                            name="st"
                            label="REPROVADO"
                            value="Reprovado"
                            id={`checkbox_reprovado`}
                            onChange={(e) => setStatusEscolhido(e.target.value)}
                            checked={statusEscolhido === "Reprovado"}
                            disabled={indiceEscolhido.indice === undefined}
                        />
                    </div>
                </section>
            </section>
            <div className={styles.finalizar_button_wrapper}>
                <Button
                    variant="success"
                    className={styles.buttonsFinalizar}
                    onClick={() => handleFinalizarPeca()}
                >
                    Finalizar Peça
                </Button>
            </div>
        </>
    );
};

export default OptionsSection;